import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import type { DealTypeFindInterface } from '@zaoblako/shared/modules/business/dto/deal-type/deal-type.find.dto';
import type { DealTypeFormInterface } from '@zaoblako/shared/modules/business/dto/deal-type/deal-type.form.dto';
import type { DealTypePageInterface } from '@zaoblako/shared/modules/business/dto/deal-type/deal-type-page.dto';
import type { DealTypeQueryInterface } from '@zaoblako/shared/modules/business/dto/deal-type/deal-type-query.dto';
import type { WithDeletedQueryInterface } from '@zaoblako/shared/common/dtos/with-deleted-query.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class DealTypeService extends BaseService {
  protected baseUrl = '/finance/business/deal-type';

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public findPage = (queryParams?: DealTypeQueryInterface): Observable<DealTypePageInterface> => {
    return this.http.get<DealTypePageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  };

  public findOne = (id: number, queryParams?: WithDeletedQueryInterface): Observable<DealTypeFindInterface> => {
    return this.http.get<DealTypeFindInterface>(`${this.baseUrl}/${id}`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  };

  public createOne = (body: DealTypeFormInterface): Observable<DealTypeFindInterface> => {
    return this.http.post<DealTypeFindInterface>(this.baseUrl, body);
  };

  public updateOne = (id: number, body: DealTypeFormInterface): Observable<DealTypeFindInterface> => {
    return this.http.put<DealTypeFindInterface>(`${this.baseUrl}/${id}`, body);
  };

  public deleteOne = (id: number): Observable<DealTypeFindInterface> => {
    return this.http.delete<DealTypeFindInterface>(`${this.baseUrl}/${id}`);
  };

  public restoreOne = (id: number): Observable<DealTypeFindInterface> => {
    return this.http.post<DealTypeFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  };
}

